export async function getAdminInfoSSR(data: any): Promise<any> {
  return await $fetch('/api/website/info', {
    method: 'POST',
    body: data
  })
}


